import { render, staticRenderFns } from "./SiteBadge.vue?vue&type=template&id=5e885abe&scoped=true"
import script from "./SiteBadge.vue?vue&type=script&lang=js"
export * from "./SiteBadge.vue?vue&type=script&lang=js"
import style0 from "./SiteBadge.vue?vue&type=style&index=0&id=5e885abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e885abe",
  null
  
)

export default component.exports